import { IconDefinition } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Skeleton } from './Skeleton';

type HeaderProps = {
  border?: boolean;
  icon?: IconDefinition;
  title: string;
  loading?: boolean;
};

export function Header({ border = false, icon, loading, title }: HeaderProps) {
  if (loading) {
    return (
      <div className="flex gap-2 border-b border-white border-opacity-10 pb-3">
        <Skeleton className="h-6 w-6 rounded-full border-white border-opacity-80" />
        <Skeleton className="h-6 w-20" />
      </div>
    );
  }
  return (
    <div
      className={`${
        border ? 'border-b border-white border-opacity-80' : ''
      } flex items-center gap-2 pb-3`}
    >
      {icon && <FontAwesomeIcon icon={icon} />}
      <h2>{title}</h2>
    </div>
  );
}
